import owd from 'owd/owd';
import _ from 'underscore';

export default class Works extends owd.Component {
	init() {
        this.page = 0;
        this.totalPages = null;
        this.perPage = 24;
        this.vh = this.dom.$window.height();
        this.slidesCount = 0;

        this.bind();
        this.load();

        $('.footer').css('display', 'none');

        this.$element.data('works.api', this);
	}

	bind() {
        this.on('resize', this.dom.$window, () => {
            this.vh = this.dom.$window.height();
        });

        this.on('scroll layout-reflow', this.dom.$window, _.throttle(() => {
            const bbox = this.$element[0].getBoundingClientRect();

            if (bbox.bottom - this.vh/2 < this.vh) {
                this.load();
            }
        }, 500));

        this.on('slideChange', this.getSwiperApi(), () => {
            const swiper = this.getSwiperApi();

            if (swiper.realIndex + 5 > this.slidesCount && this.page < this.totalPages) {
                this.load();
            }
        });
    }

    applyFilter(filter) {
        if (filter) {
            if (!this.currentFilter) {
                this.currentFilter = [];
            }
            this.currentFilter.push(filter);
            this.page = 0;
            this.getListApi() && this.getListApi().clearItems();
            this.load();
        } else if (this.currentFilter) {
            this.currentFilter = undefined;
            this.page = 0;
            this.getListApi() && this.getListApi().clearItems();
            this.load();
        }
    }

    getListApi() {
        return this.$element.data('longList.api');
    }

    getSwiperApi() {
        return $('[data-slider-fullscreen]').data('swiperInstance');
    }

    load() {
        if (!this._isDestroyed && !this.isLoading && (!this.totalPages || this.page+1 <= this.totalPages)) {

            const templateName = 'works-item';
            const slideTemplateName = 'slide';
            const tax_query = [
                {
                    'taxonomy' : 'videos_tax',
					'field'    : 'term_id',
					'terms'    : '24',
					'operator' : 'NOT IN'
                }
            ];

            if (this.currentFilter) {
                tax_query.push({
                    'taxonomy' : 'videos_tax',
                    'field'    : 'slug',
                    'operator' : 'IN',
					'terms'    : this.currentFilter
                })
            }

            $('.footer').css('display', 'none');

            this.isLoading = true;
            this.xhr = $.getJSON(`${apiurl}wp/v2/video?orderby=menu_order&order=asc&per_page=${this.perPage}&page=${(this.page+1)}&filter[tax_query]=${JSON.stringify(tax_query)}`).then((posts, status, xhr) => {
                this.totalPages = xhr.getResponseHeader('X-WP-TotalPages');
                this.isLoading = false;
                this.page++;

                const items = posts.map((item, index) => {
                    item.cssClass = item.videos_tax.join(' ');

                    if (index%2 !== 0) {
                        item.cssClass += ' video-container-odd';
                    }

                    const html = this.app.getModule('handlebars').render(templateName, item);
                    const $item = $(html);

                    this.app.tick($item);

                    return $item;
                });

                if (this.page == 1) {
                    this.getListApi() && this.getListApi().clearItems();
                }

                this.getListApi() && this.getListApi().appendItems(items);

                let offset = 0;
                
                $('[data-slider-fullscreen] .swiper-wrapper .slide').each((index, item) => {
                    let number = $(item).data('slide-number');

                    if (number) {
                        offset = Math.max(number + 1, offset);
                    }
                });

                const slides = posts.map((item, index) => {
                    const html = this.app.getModule('handlebars').render(slideTemplateName, item);
                    const $item = $(html);
                    $item.addClass('swiper-slide');
                    $item.attr('data-slide-number', index + offset);

                    return $item[0];
                });

                if (this.page == 1) {
                    this.getSwiperApi().removeAllSlides();
                    this.slidesCount = 0;
                }

                this.slidesCount += slides.length;

                this.getSwiperApi().appendSlide(slides);
                this.getSwiperApi().update();

                if (this.page < this.totalPages) {
                    $('.footer').css('display', 'none');
                } else {
                    $('.footer').css('display', '');
                }

                setTimeout(() => {
                    $('[data-slider-fullscreen] .swiper-wrapper .slide').each((index, item) => {
                        this.app.tick($(item));
                    });

                    this.dom.$window.trigger('layout-reflow');
                    this.dom.$window.trigger('slider-updated');
                });
            });
        }
    }

    destroy() {
        super.destroy();
        this._isDestroyed = true;
        $('.footer').css('display', '');
    }
}

owd.registerComponent('works', {
	component: Works
});
